module.exports = __webpack_public_path__ + "static/media/5_fanout_to_multifiber_B_BW_square.144935b2.png";